import React from "react";
import Title from "./Title";
export interface QuotePropsModel {
  quote: string | undefined;
  quoteAuthor: string | undefined;
  quoteAuthorSubTitle: string | undefined;
  quoteBgColor: string | undefined;
}

const Quote: React.FunctionComponent<QuotePropsModel> = ({
  quote,
  quoteAuthor,
  quoteAuthorSubTitle,
  quoteBgColor,
}) => {
  return (
    <div
      className="flex flex-col items-start text-center p-8 xl:py-10 max-w-[737px] rounded-2xl"
      style={{
        backgroundColor: quoteBgColor ?? "white",
      }}
    >
      {quote && (
        <Title variant="paragraph" titleText={quote} className="text-left" />
      )}
      {quoteAuthor && (
        <Title
          variant="h3"
          titleText={quoteAuthor}
          className="text-left mt-8 mb-0"
        />
      )}
      {quoteAuthorSubTitle && (
        <Title
          variant="paragraph"
          titleText={quoteAuthorSubTitle}
          className="text-left text-zinc-500"
        />
      )}
    </div>
  );
};

export default Quote;
